import React, { useEffect, useState } from "react";
import {
  FiHome,
  FiBarChart2,
  FiClock,
  FiUsers,
  FiCheckCircle,
  FiSettings,
  FiHelpCircle,
  FiSearch,
  FiBell,
  FiMenu,
  FiX,
  FiDownload,
  FiFilter,
  FiChevronDown,
  FiBookOpen,
  FiTarget,
  FiCalendar,
  FiLoader,
  FiPlay,
  FiAlertCircle,
} from "react-icons/fi";
// Import your components
import PorfileCard from "./profileCard.js";
import DashBoardExamListTable from "./Exam/DashBoardExamList";
import Navbar from "./Navbar.js";
import Assignments from "./Exam/assignmentCard.js";
import Sidebar from "./SideBar.js";
import { showErrorMessages } from "../../../services/utilityFunctions.js";
import { getLocalStorageData } from "../../../services/axiosComponent.js";
import LoadingSpinner from "./common/LoadingSpinner.js";
import { getStudentDetails } from "../../../services/student-Services.js";
import { useNavigate } from "react-router-dom";

// Simple Calendar Component
const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const today = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const previousMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const renderCalendarDays = () => {
    const days = [];

    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const isToday =
        today.getDate() === day &&
        today.getMonth() === month &&
        today.getFullYear() === year;

      days.push(
        <div key={day} className={`calendar-day ${isToday ? "today" : ""}`}>
          {day}
        </div>
      );
    }

    return days;
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={previousMonth} className="calendar-nav-btn">
          ‹
        </button>
        <h3 className="calendar-title">
          {monthNames[month]} {year}
        </h3>
        <button onClick={nextMonth} className="calendar-nav-btn">
          ›
        </button>
      </div>

      <div className="calendar-weekdays">
        {dayNames.map((day) => (
          <div key={day} className="calendar-weekday">
            {day}
          </div>
        ))}
      </div>

      <div className="calendar-grid">{renderCalendarDays()}</div>

      <style jsx>{`
        .calendar-container {
          width: 100%;
        }
        .calendar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #e2e8f0;
        }
        .calendar-title {
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }
        .calendar-nav-btn {
          background: none;
          border: none;
          font-size: 1.25rem;
          color: #64748b;
          cursor: pointer;
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          transition: background 0.2s;
        }
        .calendar-nav-btn:hover {
          background: #f1f5f9;
        }
        .calendar-weekdays {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 0;
          margin-bottom: 0.5rem;
        }
        .calendar-weekday {
          padding: 0.4rem;
          text-align: center;
          font-size: 0.7rem;
          font-weight: 600;
          color: #64748b;
          text-transform: uppercase;
        }
        .calendar-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 1px;
          background: #e2e8f0;
          border-radius: 6px;
          overflow: hidden;
        }
        .calendar-day {
          background: white;
          padding: 0.5rem;
          text-align: center;
          font-size: 0.8rem;
          color: #1e293b;
          cursor: pointer;
          transition: background 0.2s;
          min-height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .calendar-day:hover {
          background: #f1f5f9;
        }
        .calendar-day.empty {
          cursor: default;
        }
        .calendar-day.empty:hover {
          background: white;
        }
        .calendar-day.today {
          background: #3b82f6;
          color: white;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

const MainScreen = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [studentDetails, setStudentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDetails = async () => {
    try {
      const response = await getStudentDetails({
        userId: getLocalStorageData("profileDetails")["_ID"],
      });
      if (response.status == "success") {
        setStudentDetails(response.data);
        setError(null);
      } else {
        setError(response.message);
        showErrorMessages({ data: response, navigate: navigate });
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <main className="main-content">
      <div className="content-grid">
        {/* Left Column */}
        <div className="left-column">
          {/* Stats Cards */}
          <div className="stats-cards">
            <div className="stat-card">
              <div className="stat-icon students-icon">
                <FiUsers size={20} />
              </div>
              <div className="stat-content">
                <div className="stat-label">Students</div>
                <div
                  className="stat-number"
                  onClick={() => {
                    toggleSidebar();
                  }}
                >
                  50078
                </div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon awards-icon">
                <FiTarget size={20} />
              </div>
              <div className="stat-content">
                <div className="stat-label">Awards</div>
                <div className="stat-number">60+</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon department-icon">
                <FiHome size={20} />
              </div>
              <div className="stat-content">
                <div className="stat-label">Department</div>
                <div className="stat-number">50078</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon revenue-icon">
                <FiBarChart2 size={20} />
              </div>
              <div className="stat-content">
                <div className="stat-label">Revenue</div>
                <div className="stat-number">$625</div>
              </div>
            </div>
          </div>

          <div className="exam-section" style={{ height: "30vw" }}>
            <DashBoardExamListTable userId={studentDetails._ID} />
          </div>

          <div className="section-card calendar-section">
            <Calendar />
          </div>
        </div>

        {/* Right Column */}
        <div className="right-column">
          <PorfileCard profileDetails={studentDetails} />
          <Assignments />

          {/* Messages Section */}
          <div className="messages-section">
            <h4>Latest Message</h4>
            <div className="message-avatars">
              <img
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face"
                alt="User"
              />
              <div className="message-badge">AK</div>
              <img
                src="https://images.unsplash.com/photo-1494790108755-2616b612b65c?w=32&h=32&fit=crop&crop=face"
                alt="User"
              />
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=32&h=32&fit=crop&crop=face"
                alt="User"
              />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .main-content {
          padding: 2rem;
          background: #f8fafc;
          min-height: calc(100vh - 70px);
          overflow-y: auto;
          transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .content-grid {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 2rem;
          align-items: start;
        }

        .left-column,
        .right-column {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .stats-cards {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 0.75rem;
          margin-bottom: 0.75rem;
        }

        .stat-card {
          background: white;
          padding: 0.75rem;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          gap: 0.5rem;
          min-width: 0;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          cursor: pointer;
        }

        .stat-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .stat-icon {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
        }

        .students-icon {
          background: #3b82f6;
        }
        .awards-icon {
          background: #f59e0b;
        }
        .department-icon {
          background: #10b981;
        }
        .revenue-icon {
          background: #ef4444;
        }

        .stat-content {
          flex: 1;
          min-width: 0;
        }

        .stat-label {
          font-size: 0.75rem;
          color: #64748b;
          margin-bottom: 0.25rem;
          line-height: 1.2;
        }

        .stat-number {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1e293b;
          line-height: 1.2;
        }

        .section-card {
          background: white;
          border-radius: 12px;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .messages-section {
          background: white;
          border-radius: 12px;
          padding: 2rem;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .messages-section h4 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 1.5rem 0;
        }

        .message-avatars {
          display: flex;
          gap: 0.75rem;
          flex-wrap: wrap;
        }

        .message-avatars img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
        }

        .message-badge {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #3b82f6;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          font-weight: 600;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .content-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
        }

        @media (max-width: 1200px) {
          .stats-cards {
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 1rem;
          }

          .stats-cards {
            grid-template-columns: 1fr;
            gap: 0.75rem;
          }

          .stat-card {
            padding: 0.75rem;
          }
        }
      `}</style>
    </main>
  );
};

// Main Dashboard Component
const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  // Set initial sidebar state based on screen size
  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);

      if (desktop) {
        setSidebarOpen(true); // Always open on desktop
      } else {
        setSidebarOpen(false); // Closed on mobile/tablet
      }
    };

    // Set initial state
    handleResize();

    // Listen for resize events
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    // On desktop, don't allow toggling the sidebar
    if (isDesktop) return;
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    // On desktop, don't allow closing the sidebar
    if (isDesktop) return;
    setSidebarOpen(false);
  };

  return (
    <div className="dashboard-container">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <div
        className={`dashboard-main ${
          isDesktop && sidebarOpen ? "sidebar-open" : ""
        }`}
      >
        <Navbar onToggleSidebar={toggleSidebar} />
        <MainScreen toggleSidebar={toggleSidebar} />
      </div>

      <style jsx>{`
        .dashboard-container {
          display: flex;
          height: 100vh;
          background: #f8fafc;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
            sans-serif;
          overflow: hidden;
          position: relative;
        }

        .dashboard-main {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-width: 0;
          height: 100vh;
          background: white;
          transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          z-index: 1;
          margin-left: 0;
        }

        /* Desktop: Adjust main content when sidebar is open */
        .dashboard-main.sidebar-open {
          margin-left: 280px;
        }

        /* Mobile/Tablet: Force no margin */
        @media (max-width: 1023px) {
          .dashboard-main,
          .dashboard-main.sidebar-open {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Dashboard;
